
const endpoint = `https://${process.env.REACT_APP_DOMAIN}/api/log`;

export const genericLog = async (message) => {
  navigator.sendBeacon(
    endpoint,
    JSON.stringify({
        gtl_message: message,
        })
  );
};

//export default beacon;
